import { render, staticRenderFns } from "./CustomerHistory.vue?vue&type=template&id=79f1f1ae"
import script from "./CustomerHistory.vue?vue&type=script&lang=js"
export * from "./CustomerHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports